export const SECTION_BY_PATH = {
  "/": "dashboard", "/leads": "leads", "/site-visits": "site_visits", "/follow-ups": "follow_ups", "/whatsapp": "whatsapp",
  "/callerdesk": "callerdesk", "/projects": "projects", "/inventory": "inventory", "/reports": "reports", "/lead-sources": "lead_sources",
  "/data-import": "data_import", "/wa-templates": "wa_templates", "/message-templates": "message_templates",
  "/bulk-allocation": "bulk_allocation", "/partners": "partners", "/proposals": "proposals", "/team": "team", "/settings": "settings",
};

export const sectionForPath = (pathname) => {
  if (pathname === "/") return "dashboard";
  const first = `/${pathname.split("/")[1] || ""}`;
  return first === "/" ? null : SECTION_BY_PATH[first] || null;
};

export const canAccess = (user, section) => !section || !user?.sections || user.sections.includes(section);
